export enum DocumentVisibility {
    None = 0,
    Everyone = 1,
    AdminsOnly = 10
}